"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBase = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.TabBase = styled_components_1.default.button `
  padding: 16px;
  text-transform: uppercase;
  background: ${({ theme }) => theme.white};
  border: none;
  font-weight: 400;
  color: ${({ isActive, theme }) => isActive ? theme.primary.main : theme.text.secondary};
  cursor: pointer;
  position: relative;
  transition: all 0.1s;
  font-size: ${({ size }) => (size === "lg" ? "16px" : "14px")};

  ${({ isActive }) => isActive &&
    (0, styled_components_1.css) `
      &:after {
        content: "";
        position: absolute;
        width: calc(100% - 30px); // compensation for padding -1px
        height: 2px;
        left: 15px; // compensation for padding -1px
        bottom: -1px;
        background-color: ${({ theme }) => theme.primary.main};
      }
    `}

  &:hover {
    color: ${({ theme }) => theme.primary.main};
    &:after {
      content: "";
      position: absolute;
      width: calc(100% - 30px); // compensation for padding -1px
      height: 2px;
      left: 15px; // compensation for padding -1px
      bottom: -1px;
      background-color: ${({ theme }) => theme.primary.main};
    }
  }
`;
